export default function joinValues(values) {
  if (Array.isArray(values)) {
    return values.join(';') || undefined;
  }

  return values || undefined;
}
